import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = ["data-success"]
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "scrollbar" }
const _hoisted_5 = {
  key: 0,
  class: "intro"
}
const _hoisted_6 = {
  class: "maintitle s40",
  id: "modal-title"
}
const _hoisted_7 = { class: "maintitle s24 light" }
const _hoisted_8 = ["aria-busy"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  class: "item",
  "data-label": "top"
}
const _hoisted_11 = {
  for: "Type",
  class: "maintitle s16"
}
const _hoisted_12 = { value: null }
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  class: "item",
  "data-label": "top"
}
const _hoisted_15 = {
  for: "Message",
  class: "maintitle s16"
}
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = ["disabled"]
const _hoisted_18 = { class: "maintitle s24" }
const _hoisted_19 = { class: "item" }
const _hoisted_20 = {
  for: "Company",
  class: "maintitle s16"
}
const _hoisted_21 = { class: "item" }
const _hoisted_22 = {
  for: "Name",
  class: "maintitle s16"
}
const _hoisted_23 = { class: "item" }
const _hoisted_24 = {
  for: "Email",
  class: "maintitle s16"
}
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "checkbox" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = {
  key: 0,
  class: "validation-summary-errors",
  role: "alert",
  "aria-live": "polite"
}
const _hoisted_29 = { class: "cta" }
const _hoisted_30 = {
  key: 1,
  class: "button"
}
const _hoisted_31 = { class: "item" }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = {
  key: 2,
  class: "success"
}
const _hoisted_34 = { class: "maintitle s60" }
const _hoisted_35 = { class: "maindesc s16 light" }
const _hoisted_36 = { class: "cta" }

import { ref, reactive, computed, watch } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import Axios from "axios";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoRequest',
  props: {
    recaptchaSiteKey: {},
    requestUrl: {},
    privacyPolicyUrl: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore();
const route = useRoute();

const localizer = Localizer;
const routes = (window as any).App.routes;

const isLoading = ref(false);
const isSuccess = ref(false);
const types = ref<any[]>([]);
const formData = reactive<any>({ type: null });
const validationErrors = ref<any[]>([]);
const infoRequestModal = ref<HTMLElement | null>(null);

const isInfoRequestVisible = computed(() => store.getters["infoRequestStore/isInfoRequestVisible"]);

watch(isInfoRequestVisible, async (newValue) => {
    if (newValue) {
        await getData();
        document.body.classList.add("overflow");
        infoRequestModal.value?.classList.add("show");
    } else {
        document.body.classList.remove("overflow");
        infoRequestModal.value?.classList.remove("show");
    }
});

setOpenInfoRequest();

async function getData() {
    const result = (await Axios.post(routes.Support_GetInfoRequestData)).data;
    types.value = result.types;
}

async function formSubmit() {
    FormHelper.removeFocus();

    validationErrors.value = [];
    isLoading.value = true;

    (window as any).grecaptcha.enterprise.ready(async () => {
        const token = await (window as any).grecaptcha.enterprise.execute(props.recaptchaSiteKey, { action: 'Submit' });

        try {
            await Axios.post(routes.Support_InfoRequest, formData, { headers: { "RecaptchaVerificationToken": token } });
            isSuccess.value = true;
            GTagHelper.sendEvent("form_submit", "info_request", formData.type?.toLowerCase());
        } catch (error: any) {
            if (error.response && error.response.status === 400) {
                validationErrors.value = FormHelper.getValidationErrors(error.response.data);
            }
        }
        isLoading.value = false;
    });
}

function setOpenInfoRequest() {
    if (route.query.hasOwnProperty("inforequest")) {
        store.commit("infoRequestStore/setInfoRequestVisible", true);
    }
}

function closeInfoRequest() {
    store.commit("infoRequestStore/setInfoRequestVisible", false);
    isLoading.value = false;
    isSuccess.value = false;
    Object.assign(formData, { type: null });
    validationErrors.value = [];
}

function isValidationError(controlName: string): boolean {
    return FormHelper.isControlValidationError(controlName, validationErrors.value);
}

return (_ctx: any,_cache: any) => {
  const _directive_close_dialog = _resolveDirective("close-dialog")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "modal",
    role: "dialog",
    "aria-modal": "true",
    "aria-labelledby": "modal-title",
    "data-success": isSuccess.value,
    ref_key: "infoRequestModal",
    ref: infoRequestModal
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "button fastic-close",
        id: "InfoRequestClose",
        "aria-label": _unref(localizer).get('Contact.InfoRequest.Close'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (closeInfoRequest()))
      }, null, 8, _hoisted_3),
      _createElementVNode("div", _hoisted_4, [
        (!isSuccess.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(localizer).get("App.Common.Name")), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(localizer).get("Contact.InfoRequest.Abstract")), 1)
            ]))
          : _createCommentVNode("", true),
        (!isSuccess.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "form",
              "aria-busy": isLoading.value
            }, [
              _createElementVNode("fieldset", { disabled: isLoading.value }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(localizer).get("App.Common.SelectArgument")), 1),
                  _withDirectives(_createElementVNode("select", {
                    id: "Type",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.type) = $event)),
                    class: _normalizeClass([{ 'input-validation-error': isValidationError('Type') }, 'input w460'])
                  }, [
                    _createElementVNode("option", _hoisted_12, _toDisplayString(_unref(localizer).get("App.Common.SelectArgument")), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(types.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: item.value,
                        key: index
                      }, _toDisplayString(item.title), 9, _hoisted_13))
                    }), 128))
                  ], 2), [
                    [_vModelSelect, formData.type]
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("label", _hoisted_15, _toDisplayString(_unref(localizer).get('App.Common.DescRequest')), 1),
                  _withDirectives(_createElementVNode("textarea", {
                    name: "Message",
                    id: "Message",
                    placeholder: _unref(localizer).get('App.Common.DescRequest'),
                    cols: "30",
                    rows: "6",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.message) = $event)),
                    class: _normalizeClass([{ 'input-validation-error': isValidationError('Message') }, 'input w650 textarea'])
                  }, null, 10, _hoisted_16), [
                    [
                      _vModelText,
                      formData.message,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ])
              ], 8, _hoisted_9),
              _createElementVNode("fieldset", { disabled: isLoading.value }, [
                _createElementVNode("h2", _hoisted_18, _toDisplayString(_unref(localizer).get("App.Common.Help")), 1),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("label", _hoisted_20, _toDisplayString(_unref(localizer).get("App.Common.Company")), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "Company",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.company) = $event)),
                    class: _normalizeClass([{ 'input-validation-error': isValidationError('Company') }, 'input w300'])
                  }, null, 2), [
                    [
                      _vModelText,
                      formData.company,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("label", _hoisted_22, _toDisplayString(_unref(localizer).get("App.Common.NameSurname")), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "Name",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.name) = $event)),
                    class: _normalizeClass([{ 'input-validation-error': isValidationError('Name') }, 'input w300'])
                  }, null, 2), [
                    [
                      _vModelText,
                      formData.name,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("label", _hoisted_24, _toDisplayString(_unref(localizer).get("App.Common.Email")), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    id: "Email",
                    placeholder: "name@domain.com",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.email) = $event)),
                    class: _normalizeClass([{ 'input-validation-error': isValidationError('Email') }, 'input w300'])
                  }, null, 2), [
                    [
                      _vModelText,
                      formData.email,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ])
              ], 8, _hoisted_17),
              _createElementVNode("fieldset", { disabled: isLoading.value }, [
                _createElementVNode("div", _hoisted_26, [
                  _withDirectives(_createElementVNode("input", {
                    type: "checkbox",
                    id: "DialogIsPrivacy",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.isPrivacyPolicy) = $event))
                  }, null, 512), [
                    [
                      _vModelCheckbox,
                      formData.isPrivacyPolicy,
                      void 0,
                      { lazy: true }
                    ]
                  ]),
                  _createElementVNode("label", {
                    for: "DialogIsPrivacy",
                    innerHTML: _unref(localizer).get('App.Form.Privacy', __props.privacyPolicyUrl)
                  }, null, 8, _hoisted_27)
                ]),
                (validationErrors.value.length !== 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (validationError, index) => {
                          return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(validationError.message), 1))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_29, [
                  (!isLoading.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "button",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (formSubmit()))
                      }, _toDisplayString(_unref(localizer).get("App.Common.SubmitCta")), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(_unref(localizer).get("App.Common.SubmitCta")), 1))
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("div", {
                    class: "captcha-terms",
                    innerHTML: _unref(localizer).get('App.Recaptcha.CaptchaTerms')
                  }, null, 8, _hoisted_32)
                ])
              ], 8, _hoisted_25)
            ], 8, _hoisted_8))
          : (_openBlock(), _createElementBlock("div", _hoisted_33, [
              _createElementVNode("h2", _hoisted_34, _toDisplayString(_unref(localizer).get("App.Common.SubmitSuccess")), 1),
              _createElementVNode("p", _hoisted_35, _toDisplayString(_unref(localizer).get("App.Common.SubmitSuccessMessage")), 1),
              _createElementVNode("div", _hoisted_36, [
                _createElementVNode("button", {
                  class: "button secondary",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (closeInfoRequest()))
                }, _toDisplayString(_unref(localizer).get("App.Common.GoNavigation")), 1)
              ])
            ]))
      ])
    ])
  ], 8, _hoisted_1)), [
    [_directive_close_dialog, closeInfoRequest]
  ])
}
}

})